const dateOnly = (value) => {
  const text = String(value || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return "";
  const date = new Date(`${text}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === text ? text : "";
};
const format = (date) => date.split("-").reverse().join("/");

export function getOperationTransfers(operation, day) {
  const current = dateOnly(day);
  if (!current) return { incoming: "", outgoing: "", summary: "" };
  const source = [operation?.pospuestoDe, operation?.origenFecha, operation?.origen?.fecha]
    .map(dateOnly).find(Boolean);
  const trucks = Array.isArray(operation?.camiones) ? operation.camiones : [];
  const mapping = operation?.origen?.camionesMap;
  const indices = Array.isArray(mapping) && mapping.length
    ? mapping.map((truck) => Number(truck.nuevoIndex))
    : trucks.filter((truck) => truck.origenIndex != null).map((truck) => Number(truck.index));
  const transferred = [...new Set(indices)].filter((index) => Number.isInteger(index) && index >= 0 &&
    (!trucks.length || trucks.some((truck) => Number(truck.index) === index)));
  const detail = source ? `trasladado del ${format(source)} al ${format(current)}` : "";
  const incoming = source && source !== current
    ? transferred.length
      ? transferred.map((index) => `Camión ${index + 1}: ${detail}.`).join("\n")
      : `Operativa trasladada del ${format(source)} al ${format(current)}.`
    : "";
  // Dates equal to today on a continuation are history, not another departure.
  const destinations = [...new Set([
    operation?.pospuestoA, operation?.pasarMananaDia, ...trucks.map((truck) => truck.pospuestoA),
  ].map(dateOnly).filter((destination) => destination && destination > current))].sort();
  const outgoing = destinations.map((destination) =>
    `Trasladada del ${format(current)} al ${format(destination)}.`).join("\n");
  const summary = [
    source && source < current ? `Trasladada del ${format(source)} al ${format(current)}.` : "",
    ...destinations.map((destination) => `Trasladada al ${format(destination)}.`),
  ].filter(Boolean).join("\n");
  return { incoming, outgoing, summary };
}
